export enum SetOperationEnum {
    union,
    intersect,
    except
}
